import { put } from 'redux-saga/effects';

import { t } from '$app-web/i18n';
import { APIMappedError } from '$app-web/utils';

import * as appMainStore from '../store';

export function* showAPIErrorSnackbar(error) {
    let errorMessage = t('generic_error_msg');
    if (error instanceof APIMappedError) {
        errorMessage = error.message;
    }
    yield put(
        appMainStore.snackbarDuck.duckActionCreators.show({
            variant: 'error',
            message: errorMessage,
        })
    );
}
